window.addEventListener('DOMContentLoaded', () => {
    const scrollElements = document.querySelector(".scroll-up");
 
    if(scrollElements) {
        function scrollToTop() {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }

        scrollElements.addEventListener("click", () => {
          scrollToTop();
        })
    }
 })